import { UploadETicketsModalProps } from 'src/modals/UploadETickets';
import { UploadETicketsV2 } from 'src/modals/UploadETickets/UploadETicketsV2';

type UploadETicketsVersionSelectorProps = UploadETicketsModalProps;

export const UploadETicketsSelector = (
  props: UploadETicketsVersionSelectorProps
) => {
  return <UploadETicketsV2 {...props} />;
};
